import { getChinaCode } from '@libs/shared';
import { TEXT_TYPE_REGEXP } from '~/constants';

/**
 * 手机号校验
 *
 * @param phone
 * @param isInternational 是否为国际化手机号
 */
export const verifyPhone = (phone: string, isInternational?: boolean) => {
    if (!isInternational) {
        return new RegExp(TEXT_TYPE_REGEXP.MOBILE).test(phone);
    }
    // 校验国际手机号
    const match = phone.split('-');
    const areaCode = match[0];
    const mobileNum = match[1];
    if (areaCode === getChinaCode()) {
        return new RegExp(TEXT_TYPE_REGEXP.MOBILE).test(mobileNum!);
    } else {
        return new RegExp(TEXT_TYPE_REGEXP.INTER_MOBILE).test(phone);
    }
};
/**
 * 邮箱校验
 *
 * @param email
 */
export const verifyEmail = (email: string) => {
    return new RegExp(TEXT_TYPE_REGEXP.EMAIL).test(email);
};
